/* eslint react/prefer-stateless-function: "off" */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import { getAccuracyRanges } from '../../../../client/lib/macmillan'

import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'

import RestrictableButton from '../RestrictableButton'
import panelStyle from 'Styles/panel.css'
import style from './style.css'
import colors from 'Styles/baseColors.css'

export default class TargetAndTopicSummary extends Component {
  targetPieChartSlices () {
    const notStarted = this.props.totalStudents - this.props.startedStudents
    const startedNotCompleted = this.props.startedStudents - this.props.completedStudents
    return (
      [
        {
          color: colors.colorBlueLighter,
          value: startedNotCompleted
        },
        {
          color: colors.colorBlueDarker,
          value: this.props.completedStudents
        },
        {
          color: '#fff',
          value: notStarted
        }
      ]
    )
  }

  renderTargetButton () {
    return (
      <RestrictableButton
        id="targetAndTopicSummaryTargetScoreEditBtn"
        clickEventHandler={this.props.onEditTargetScoreClick}
        hidden={false}
        tabIndex={0}
        dataTestId="targetAndTopicSummaryTargetScoreEditBtn"
        restricted={this.props.isRestrictedInstructor}
        buttonText="Edit Target"
        ariaLabel="Edit Target"
        textButton
      />
    )
  }

  renderTopicButton () {
    return (
      <RestrictableButton
        id="targetAndTopicSummaryTopicCountBtn"
        clickEventHandler={this.props.onEditTopicsClick}
        hidden={!this.props.showEditTopicsButton}
        tabIndex={0}
        dataTestId="targetAndTopicSummaryTopicCountBtn"
        restricted={this.props.isRestrictedInstructor}
        buttonText="Edit Topics"
        ariaLabel="Edit Topics"
        textButton
      />
    )
  }

  renderHowIsCalculated (type) {
    return (
      <RestrictableButton
        id="howIsCalculatedBtnId"
        clickEventHandler={() => this.props.showHowIsCalculated(type)}
        tabIndex={0}
        dataTestId="howIsCalculatedBtn"
        buttonText="How is this calculated?"
        ariaLabel="How is this calculated?"
        textButton
        className={style.howIsCalculatedBtn}
      />
    )
  }

  distributionPieChartSlices (accuracy) {
    if (!this.props.studentData.length) {
      return (
        [
          {
            color: colors.colorYellowMedium,
            value: 0
          },
          {
            color: colors.colorGreenMedium,
            value: 0
          },
          {
            color: '#fff',
            value: 0
          }
        ]
      )
    }
    return (
      [
        {
          color: colors.colorYellowMedium,
          value: accuracy.mediumAccuracyPercent
        },
        {
          color: colors.colorGreenMedium,
          value: accuracy.highAccuracyPercent
        },
        {
          color: colors.colorRedMacmillan,
          value: accuracy.lowAccuracyPercent
        }
      ]
    )
  }

  calculateFromAccuracyArray () {
    const allStudentFirstAttemptArray = []
    let singleQuizScore = 0
    let singleQuizPointsEarned = 0
    let singleQuizPointsAvailable = 0
    if (!this.props.studentData.length || !this.props.studentData[0].activity_state) {
      return (
        {
          lowAccuracyPercent: 0,
          highAccuracyPercent: 0,
          mediumAccuracyPercent: 0
        }
      )
    }
    for (let i = 0; i < this.props.studentData.length; i++) {
      if (this.props.studentData[i].activity_state.tp) {
        // eslint-disable-next-line no-loop-func
        _.each(this.props.studentData[i].activity_state.tp, (topic, index) => {
          singleQuizPointsEarned += topic.pe
          singleQuizPointsAvailable += topic.pa
        })
        // student individual first attempt score
        singleQuizScore = Math.round(100 * (singleQuizPointsEarned / singleQuizPointsAvailable))
        if (!isNaN(singleQuizScore)) {
          const { score, target } = this.props.studentData[i].activity_state
          if (!this.props.isFromLCRP || (this.props.isFromLCRP && score >= target)) {
            allStudentFirstAttemptArray.push(singleQuizScore)
          }
        }
        singleQuizPointsEarned = 0
        singleQuizPointsAvailable = 0
        singleQuizScore = 0
      }
    }
    return getAccuracyRanges(allStudentFirstAttemptArray)
  }

  render () {
    const { ffEstimatedTimeToCompleteEnabled } = this.props
    const accuracyRanges = this.calculateFromAccuracyArray()
    let numStudents = 0
    for (let i = 0; i < this.props.studentData.length; i++) {
      const { score, target } = this.props.studentData[i].activity_state
      if ((!this.props.isFromLCRP && score > 0) || (this.props.isFromLCRP && score >= target)) {
        numStudents++
      }
    }
    let lowAccuracyCount = Math.round((accuracyRanges.lowAccuracyPercent / 100) * numStudents)
    let mediumAccuracyCount = Math.round((accuracyRanges.mediumAccuracyPercent / 100) * numStudents)
    let highAccuracyCount = Math.round((accuracyRanges.highAccuracyPercent / 100) * numStudents)
    lowAccuracyCount = isNaN(lowAccuracyCount) ? 0 : lowAccuracyCount
    mediumAccuracyCount = isNaN(mediumAccuracyCount) ? 0 : mediumAccuracyCount
    highAccuracyCount = isNaN(highAccuracyCount) ? 0 : highAccuracyCount
    const startedNotCompleted = this.props.startedStudents - this.props.completedStudents
    return (
      <div className={classnames(panelStyle.large, style.panel)}>
        <Row>
          <Col sm={4} md={3} xs={12} className={classnames(style.headerSections, style.divider)}>
            <h2 className={style.sectionHeader}>Assignment Details</h2>
            <div className={style.targetSection}>
              <p className={style.fieldLabel}>Target Score:
                <span
                  className={style.fieldValue}
                  data-test-id="targetAndTopicSummaryScoreTotal"
                >
                  {this.props.scoreTarget} pts
                </span>
              </p>
              {this.renderTargetButton()}
            </div>
            <div className={style.targetSection}>
              <p className={style.fieldLabel}>Topics:
                <span
                  className={style.fieldValue}
                  data-test-id="targetAndTopicSummaryTopicCount"
                >
                  {this.props.topicCount}
                </span>
              </p>
              {this.renderTopicButton()}
            </div>
            <p className={style.visuallyHidden}>
              Estimated Time to Complete: {this.props.estimatedTimeToComplete}&nbsp;{!isNaN(this.props.estimatedTimeToComplete) && 'min'}
            </p>
            {ffEstimatedTimeToCompleteEnabled
              ? <div className={classnames(style.targetSection, style.directionColumn)}>
                <p className={style.fieldLabel} aria-hidden="true">Est. Time to Complete:
                  <span
                    className={style.fieldValue}
                    data-test-id="estimateTimeToComplete"
                  >
                    {this.props.estimatedTimeToComplete}&nbsp;{!isNaN(this.props.estimatedTimeToComplete) && 'min'}
                  </span>
                </p>
                {this.renderHowIsCalculated('Estimated')}
              </div>
              : <div className={classnames(style.targetSection, style.directionColumn, style.estimatedTimeToCompleteSpacer)}></div>
            }
          </Col>
          <Col sm={8} md={9} xs={12}>
            <h2 className={style.sectionHeader}>Class Performance</h2>
            <Row>
              <Col sm={4} xs={12} className={classnames(style.headerSections)}>
                <div>
                  <p className={style.secondSectionHeader}>Assignment Completion</p>
                </div>
                <div>
                  <ul data-test-id="assignmentCompletion" className={classnames(style.list, style.noBullet)}>
                    <li>
                      <span>
                        <span data-test-id="targetAndTopicSummaryQuizesStarted" className={style.fieldValue}>
                          {`${startedNotCompleted} `}
                        </span>
                        in progress
                      </span>
                    </li>
                    <li>
                      <span>
                        <span data-test-id="targetAndTopicSummaryQuizesCompleted" className={style.fieldValue}>
                          {`${this.props.completedStudents} `}
                        </span>
                        Completed
                      </span>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col sm={4} xs={12} className={classnames(style.headerSections)}>
                <div>
                  <p className={style.secondSectionHeader}>Performance Distribution</p>
                </div>
                <div>
                  <ul data-test-id="performanceDistribution" className={classnames(style.list, style.accuracyList)}>
                    <li className={classnames(style.lowAccuracyBullet, style.accuracyBullet)}>
                      <span className={style.bulletDescription}>
                        <span data-test-id="targetAndTopicSummaryAccuracyLow" className={style.fieldValue}>
                          {`${lowAccuracyCount} `}
                        </span>
                        Under 70%
                      </span>
                    </li>
                    <li className={classnames(style.mediumAccuracyBullet, style.accuracyBullet)}>
                      <span className={style.bulletDescription}>
                        <span data-test-id="targetAndTopicSummaryAccuracyMedium" className={style.fieldValue}>
                          {`${mediumAccuracyCount} `}
                        </span>
                        70-89%
                      </span>
                    </li>
                    <li className={classnames(style.highAccuracyBullet, style.accuracyBullet)}>
                      <span className={style.bulletDescription}>
                        <span data-test-id="targetAndTopicSummaryAccuracyHigh" className={style.fieldValue}>
                          {`${highAccuracyCount} `}
                        </span>
                        90% and up
                      </span>
                    </li>
                  </ul>
                </div>
              </Col>
              <Col sm={4} xs={12} className={classnames(style.headerSections)}>
                <div>
                  <p className={style.visuallyHidden}>Average to Complete:</p>
                  <p className={style.secondSectionHeader} aria-hidden="true">Avg. to Complete:</p>
                  <p className={style.fieldValue} data-test-id="targetAndTopicSummaryScoreTotal">
                    {this.props.averageTimeToComplete} {!isNaN(this.props.averageTimeToComplete) && 'min'}
                  </p>
                  {this.renderHowIsCalculated('Average')}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
}

TargetAndTopicSummary.propTypes = {
  scoreTarget: PropTypes.number.isRequired,
  onEditTargetScoreClick: PropTypes.func.isRequired,
  totalStudents: PropTypes.number.isRequired,
  startedStudents: PropTypes.number,
  completedStudents: PropTypes.number,
  individualStudentSelected: PropTypes.bool.isRequired,
  showEditTopicsButton: PropTypes.bool.isRequired,
  onEditTopicsClick: PropTypes.func.isRequired,
  studentData: PropTypes.array.isRequired,
  topicCount: PropTypes.number,
  browser: PropTypes.object.isRequired,
  isFromLCRP: PropTypes.bool,
  isRestrictedInstructor: PropTypes.bool,
  showHowIsCalculated: PropTypes.func.isRequired,
  averageTimeToComplete: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  estimatedTimeToComplete: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  ffEstimatedTimeToCompleteEnabled: PropTypes.bool
}
